import React from 'react';
import './withTableHeaderIcon.css';
export default function withTableHeaderIcon() {
  return function (Icon) {
    return function (props) {
      return /*#__PURE__*/React.createElement("span", {
        className: "dm-table__header-icon--container"
      }, /*#__PURE__*/React.createElement(Icon, Object.assign({
        width: 13,
        height: 13,
        className: "dm-table__header-icon--icon"
      }, props)));
    };
  };
}